var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChoosekaamvala2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6447 16.9154L91.6257 12.6553H82.2459L69.1466 8.62695L66.6746 11.1904L72.2773 19.6158L74.8744 31.1004L79.6037 26.4656C83.849 32.325 88.2812 38.9607 88.2812 50.0098C88.2812 58.7115 85.0822 67.1 79.1212 73.6539L84.9187 84.4982C94.7386 75.2721 100 63.1031 100 50.0096C100 36.3828 94.9019 26.4447 86.6447 16.9154Z",
    fill: "#00CC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6367 89.8439L83.0076 86.5041C73.7502 94.6482 63.5352 99.9998 50 99.9998C35.4102 99.9998 21.6211 93.1834 12.5391 81.4062L21.5037 73.6719C27.9494 82.6953 38.6328 87.8516 50 87.9102H50.176C61.1912 87.9102 67.2459 83.7498 73.1053 79.9414L67.7734 76.367L85.9961 69.6289L87.6367 89.8439Z",
    fill: "#00CC71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6367 89.8439L83.0076 86.5041C73.7502 94.6482 63.5352 99.9998 50 99.9998V87.9102H50.176C61.1912 87.9102 67.2459 83.7498 73.1053 79.9414L67.7734 76.367L85.9961 69.6289L87.6367 89.8439Z",
    fill: "#00AB5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 41.2695V18.0469L50 23.3201L30.176 58.8477H47.0704V81.875L50 76.6014L69.8241 41.2695H52.9297Z",
    fill: "#FBE000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8035 85.1676L22.6992 67.1031L18.6223 71.2545C15.1168 65.393 11.7188 59.7605 11.7188 50.0113C11.7188 39.9873 15.8447 30.4912 23.5391 23.4986L16.3826 14.2188C5.9002 23.191 0 36.4289 0 50.0113C0 61.5084 3.61699 69.7645 9.54727 78.49L5.31289 81.9947L23.8035 85.1676Z",
    fill: "#00AB5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7031 12.6561L72.2854 19.6287C66.0744 14.5311 58.2033 11.8357 50 11.8357H49.9414C39.6875 11.8357 33.8674 15.4686 28.008 18.9844L33.1057 22.8514L13.8867 26.6014L14.6484 7.73398L19.043 11.4254C28.0662 4.33594 37.5195 0 50 0C61.9529 0 73.3398 4.39453 82.2459 12.6561H70.7031Z",
    fill: "#00CC71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.824 41.2695L50 76.6014V23.3201L52.9297 18.0469V41.2695H69.824Z",
    fill: "#FDBF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2854 19.6287C66.0744 14.5311 58.2033 11.8357 50 11.8357V0C61.9529 0 73.3398 4.39453 82.2459 12.6561H70.7031L72.2854 19.6287Z",
    fill: "#00AB5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosekaamvala2);
export default __webpack_public_path__ + "static/media/choosekaamvala2.da0e383b3b1f59abf83879e4fab6ffc3.svg";
export { ForwardRef as ReactComponent };